import styled from 'styled-components';
import { U21Spacer } from 'app/shared/u21-ui/components/layout/U21Spacer';
import { U21AiChatToolCallInner } from 'app/shared/u21-ui/components/input/chat/components/inner/U21AiChatToolCallInner';
import { U21AiChatMessageToolUse } from 'app/shared/u21-ui/components/input/chat/types';

interface Props {
  toolUses: U21AiChatMessageToolUse[];
}

export const U21AiChatToolCallList = ({ toolUses }: Props) => (
  <ToolUseList spacing={1}>
    {toolUses.map((toolUse) => (
      <U21AiChatToolCallInner key={toolUse.id} toolUse={toolUse} />
    ))}
  </ToolUseList>
);

const ToolUseList = styled(U21Spacer)`
  max-width: 100%;
  min-width: 0;
`;
